<div
  class="custom-drivers__header flex h-20 w-full items-center justify-between rounded-[5px] px-5 py-2.5"
>
  <span
    #name
    [auxTooltip]="
      name.offsetWidth < name.scrollWidth
        ? customCurvesQuery.selectedCurve()?.name || zeroHyphen
        : ''
    "
    class="truncate pr-2.5 text-2xl font-semibold text-[#3D444B]"
  >
    {{ customCurvesQuery.selectedCurve()?.name || zeroHyphen }}
  </span>
  <div class="flex flex-col">
    <div class="mb-1 text-sm">Select a Curve:</div>
    <div class="flex items-center gap-5">
      <div [auxTooltip]="getTooltipText()">
        <ng-select
          placeholder="Select"
          class="custom-driver__select w-64"
          [class.opacity-50]="selectedCurve.disabled"
          [trackByFn]="trackByFn"
          [clearable]="false"
          [searchable]="false"
          [formControl]="selectedCurve"
          bindLabel="name"
          bindValue="name"
          [items]="curves()"
        >
          <ng-template ng-label-tmp let-item="item">
            <div
              #label
              class="truncate"
              [auxTooltip]="label.offsetWidth < label.scrollWidth ? item.name : ''"
            >
              {{ item.name }}
            </div>
          </ng-template>

          <ng-template ng-option-tmp let-item="item">
            <div
              class="relative flex cursor-pointer select-none justify-between px-[10px] py-[8px] text-gray-900"
              (click)="onItemSelect($event, item)"
            >
              <div
                #option
                class="mr-1 flex-1 truncate"
                [auxTooltip]="option.offsetWidth < option.scrollWidth ? item.name : ''"
              >
                <span>{{ item.name }}</span>
              </div>
              <div class="actions flex items-center">
                <button
                  class="mr-1 text-aux-blue-dark"
                  [ngClass]="{ 'cursor-not-allowed opacity-50': !hasModifyCustomCurvePermission() }"
                  [auxTooltip]="noPermTooltip()"
                  (click)="onEdit($event, item)"
                  [disabled]="!hasModifyCustomCurvePermission()"
                >
                  <aux-icon name="Pencil" />
                </button>

                <button
                  class="text-aux-red-hover"
                  [disabled]="!hasModifyCustomCurvePermission()"
                  [ngClass]="{ 'cursor-not-allowed opacity-50': !hasModifyCustomCurvePermission() }"
                  [auxTooltip]="noPermTooltip()"
                  (click)="onDelete($event, item)"
                >
                  <aux-icon name="Trash" />
                </button>
              </div>
            </div>
          </ng-template>
        </ng-select>
      </div>
      <aux-button
        label="Curve"
        icon="Plus"
        class="create-curve__button"
        pendoTag="custom-curves-create-button"
        (click)="onCreateButtonClick()"
        [disabled]="!hasModifyCustomCurvePermission()"
        [auxTooltip]="noPermTooltip()"
      />
    </div>
  </div>
</div>

@if (selectedCurve.value) {
  <div class="relative mt-[20px] rounded-[20px] border border-[#BACAD0] p-[10px]">
    <div class="text-xl font-bold text-aux-black">
      Planned {{ selectedCurveDistributionLabel() }} & Forecast Distribution
    </div>
    <span class="mb-4 text-sm">{{ selectedCurveDistributionLabel() }}</span>
    @if (multiChart()) {
      <aux-canvas-chart [chartOptions]="multiChart()!" />
    }
    @if (isChartEmpty() && !distributionsRequestInProgress()) {
      <div class="absolute right-1 top-0 flex h-full w-full items-center justify-center">
        <div class="absolute mb-8 ml-2 mt-16 h-72 w-full bg-white opacity-75"></div>
        <div class="absolute mb-[18px] text-center">
          <aux-icon name="AlertTriangle" />
          <p class="text-[21px] font-bold text-aux-black">No driver data to show in this graph!</p>
          <p class="mt-2 text-xl text-aux-gray-darkest">
            Click Edit and enter driver data in the table below.
          </p>
        </div>
      </div>
    }
  </div>
}
<div class="mt-[20px] flex items-center justify-between">
  @if (curvesLoading()) {
    <div class="spinner h-9 w-9 self-end opacity-50"></div>
  }
  <div class="flex grow items-center justify-end">
    @if (editMode() || saving()) {
      <button
        type="button"
        class="btn btn--secondary"
        [disabled]="saving()"
        (click)="cancelEditMode()"
      >
        <aux-icon name="X" />
        <span class="ml-0.5">Cancel</span>
      </button>

      <aux-button
        label="Save"
        variant="success"
        icon="Check"
        classList="ml-1 btn custom-drivers__save-button"
        [disabled]="saveDisabled()"
        [auxTooltip]="computedSaveTooltip()"
        [spinnerSize]="7"
        [loading]="saving()"
        (click)="save()"
      />
    } @else {
      <aux-button
        label="Edit"
        pendoTag="custom-curves-edit-table-button"
        variant="secondary"
        icon="Pencil"
        [disabled]="editButtonDisabled()"
        [auxTooltip]="noPermTooltip() || getTooltipText()"
        (click)="editGrid()"
      />
    }

    <aux-export-excel-button
      [clickFN]="onExportCurve.bind(this)"
      [disabled]="exportDisabled()"
      [auxTooltip]="curvesLoading() ? '' : getTooltipText()"
      [spinnerSize]="7"
      class="ml-2"
      pendoTag="custom-curves-excel-export-button"
    />
  </div>
</div>

<ag-grid-angular
  class="ag-theme-aux custom-drivers-table mt-4 tabular-nums"
  domLayout="autoHeight"
  [style.visibility]="gridAPI() ? 'visible' : 'hidden'"
  [stopEditingWhenCellsLoseFocus]="true"
  [enableFillHandle]="editMode()"
  [rowData]="gridData()"
  [gridOptions]="gridOptions()"
  [suppressDragLeaveHidesColumns]="false"
  [overlayLoadingTemplate]="overlayLoadingTemplate"
  (gridReady)="gridReady($event.api)"
  (gridSizeChanged)="sizeColumnsToFit()"
  (cellValueChanged)="cellValueChanged($event)"
  (firstDataRendered)="$event.api.sizeColumnsToFit()"
  auxStickyGrid
/>
